import React from 'react';

const Pagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i);

  return (
    <div className="flex flex-wrap justify-center items-center gap-2 mt-8 text-sm">
      {/* Prev Button */}
      <button
        onClick={() => onChange(page - 1)}
        disabled={page === 0}
        className={`px-4 py-2 rounded-md border transition-all duration-200 
          ${page === 0 
            ? 'opacity-50 cursor-not-allowed bg-gray-200 text-gray-500' 
            : 'bg-white hover:bg-orange-100 border-gray-300 text-[#FF7236]'}`}
      >
        ‹ Prev
      </button>

      {/* Page Buttons */}
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className={`px-4 py-2 rounded-md border font-medium transition-all duration-200 
            ${p === page
              ? 'bg-[#FF7236] text-white border-[#FF7236] shadow-md'
              : 'bg-white text-gray-700 border-gray-300 hover:bg-orange-100 hover:text-[#FF7236]'}`}
        >
          {p + 1}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages - 1}
        className={`px-4 py-2 rounded-md border transition-all duration-200 
          ${page === totalPages - 1 
            ? 'opacity-50 cursor-not-allowed bg-gray-200 text-gray-500' 
            : 'bg-white hover:bg-orange-100 border-gray-300 text-[#FF7236]'}`}
      >
        Next ›
      </button>
    </div>
  );
};

export default Pagination;
